import Vue from 'vue';
import Component from 'vue-class-component';
import { ModelSync, Prop } from 'vue-property-decorator';
import './select.component.scss';

@Component({})
export default class SelectComponent extends Vue {
  // prop data
  @Prop({ default: false }) isSearchable!: boolean;
  @Prop({ default: false }) isShowLabels!: boolean;
  @Prop({ default: false }) isAllowEmpty!: boolean;
  @Prop({ default: false }) isShowNoOptions!: boolean;
  @Prop({ default: '' }) openDirection!: string;
  @Prop() isError!: boolean;
  @Prop() selectLabel!: string;
  @Prop() customLabel!: string;
  @Prop() options!: Array<string>;
  @ModelSync('selectedInductionId', 'input') _selectedInductionId!: string;

  render() {
    return (
      <multiselect
        vModel={this._selectedInductionId}
        custom-label={this.customLabel}
        placeholder="選択してください"
        options={this.options}
        searchable={this.isSearchable}
        show-labels={this.isShowLabels}
        selectLabel=""
        allow-empty={this.isAllowEmpty}
        showNoOptions={this.isShowNoOptions}
        openDirection={this.openDirection}
        class={{
          'select-label rounded-0 border border-2 mb-2 select-icon-arrow-down height-select text-size-20 font-weight-bold':
            true,
          'select-label border-danger bg-danger-outline': this.isError,
          'border-dark': this.isError,
          'text-gray3': this.isError
        }}
      />
    );
  }
}
